import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LookupService} from '../../../../common/service/lookup.service';
import {labelProperties, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class ControlPointLabelExpressionBuilderService {
    title = 'ControlPointLabelExpressionBuilder';

    constructor(
        private lookupService: LookupService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {}

    format(value: string, size: number) {
        return this.labelExpressionUtilityService.formatLabel(value, size, true);
    }

    getAttribute2(attrs: Attributes) {
        if (!attrs.attribute2) {
            return;
        }

        let cptLookup = this.lookupService
            .getLookups('controlPointType')
            .find(l => [l.id.toString(), l.description].includes(attrs.attribute2.toString()));
        return cptLookup && cptLookup.description;
    }

    build(attrs: Attributes) {
        console.debug(`${this.title} : build`);

        let formattedAttribute1 = this.format(attrs.attribute1, 10);
        let formattedAttributes234 = this.format([this.getAttribute2(attrs), attrs.attribute3, attrs.attribute4].filter(v => v).join('\n'), 7.2);

        let expression = [formattedAttribute1, formattedAttributes234].filter(v => v).join('\n') || null;

        let labels = [];
        let labelProperties = {} as labelProperties;

        if (attrs.attribute1) {
            let attribute1Lines = attrs.attribute1.toString().split(/[\r\n]/g);
            labels.push(...attribute1Lines.map(s => this.getLabelProperties('10em', 'normal', 'start', s)));
        }

        if (attrs.attribute2) {
            console.debug(`${this.title} : attr2 =`, this.getAttribute2(attrs));

            let attribute2Lines = this.getAttribute2(attrs).split(/[\r\n]/g);
            labels.push(...attribute2Lines.map(s => this.getLabelProperties('7.2em', 'normal', 'start', s)));
        }

        if (attrs.attribute3) {
            let attribute4Lines = attrs.attribute3.split(/[\r\n]/g);
            labels.push(...attribute4Lines.map(s => this.getLabelProperties('7.2em', 'normal', 'start', s)));
        }

        if (attrs.attribute4) {
            let attribute4Lines = attrs.attribute4.split(/[\r\n]/g);
            labels.push(...attribute4Lines.map(s => this.getLabelProperties('7.2em', 'normal', 'start', s)));
        }

        labelProperties.labels = labels;
        labelProperties.labelExpression = expression;

        return labelProperties;
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties(
            fontSize,
            fontStyle,
            textAnchor,
            this.labelExpressionUtilityService.encodeSpecialCharacters(attributes)
        );
    }
}
